import { createSlice } from "@reduxjs/toolkit";
import { setError } from "../errors/errorsSlice";
import { fetchOrFilterTransactions } from "./transService";

const initialState = {
  list: [],
  details: [],
  fetchTrx: [],
  trxSearchTerms: {},
  loading: false,
  detailsLoading: false,
};

const transactionsSlice = createSlice({
  name: "transactions",
  initialState,
  reducers: {
    setList: (state, action) => {
      const payload = action.payload;

      state.list = payload;
    },
    setDetails: (state, action) => {
      const payload = action.payload;
      state.details = payload;
    },
    setFetchTrx: (state, action) => {
      const payload = action.payload;
      state.fetchTrx = payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setDetailsLoading: (state, action) => {
      state.detailsLoading = action.payload;
    },

    setTrxSearchTerms: (state, action) => {
      state.trxSearchTerms = action.payload;
    },
  },
});

export const {
  setList,
  setLoading,
  setDetails,
  setDetailsLoading,
  setTrxSearchTerms,
  setFetchTrx,
} = transactionsSlice.actions;

export const fetchOrFilterTransactionsAsync =
  (payload = {}) =>
  async (dispatch) => {
    dispatch(setError(null));
    dispatch(setLoading(true));

    try {
      const data = await fetchOrFilterTransactions(payload);
      dispatch(setList(data));
      dispatch(setLoading(false));
      dispatch(setFetchTrx(true));
    } catch (error) {
      dispatch(setError(error));
      dispatch(setLoading(false));
    }
  };

const getTransDetail = (data, key = "id") => {
  const items = data?.data ?? [];

  for (var i = 0; i < items.length; i++) {
    const item = items[i];

    if (item.id === data[key]) {
      return {
        data: item,
      };
    }
  }
  return {};
};

export const fetchTransactionDetailsAsync =
  (payload = {}) =>
  async (dispatch) => {
    dispatch(setError(null));
    dispatch(setDetailsLoading(true));

    try {
      const data = getTransDetail(payload, "id");
      dispatch(setDetails(data));
      dispatch(setDetailsLoading(false));
    } catch (error) {
      dispatch(setError(error));
      dispatch(setDetailsLoading(false));
    }
  };

export const transactionsState = {
  list: (state) => state.transactions.list,
  loading: (state) => state.transactions.loading,
  details: (state) => state.transactions.details,
  detailsLoading: (state) => state.transactions.detailsLoading,
  trxSearchTerms: (state) => state.transactions.trxSearchTerms,
  fetchTrx: (state) => state.transactions.fetchTrx,
};

export default transactionsSlice.reducer;
